import { SpecialCase, MakeNoModel } from './types';

// Enhanced special cases with allowed model details
export const SPECIAL_CASES: SpecialCase[] = [
  {
    make: 'dodge',
    model: 'ram',
    hasModelDetail: true,
    hasCabSize: false,
    standardModelDetail: 'standard',
    allowedModelDetails: ['1500', '2500', '3500', '1500 classic', '1500 trx'],
  },
  {
    make: 'chevrolet',
    model: 'silverado',
    hasModelDetail: true,
    hasCabSize: false,
    allowedModelDetails: ['1500', '2500', '3500', '1500hd', '2500hd', '3500hd'],
  },
  {
    make: 'gmc',
    model: 'sierra',
    hasModelDetail: true,
    hasCabSize: false,
    allowedModelDetails: ['1500', '2500', '3500', '1500hd', '2500hd', '3500hd'],
  },
  {
    make: 'chevrolet',
    model: 'ck',
    hasModelDetail: true,
    hasCabSize: false,
    allowedModelDetails: ['1500', '2500', '3500'],
  },
];

export const PRODUCT_TYPES = {
  TRUCK_COVER: 'truck-cover',
  SEAT_COVERS: 'custom-seat-covers',
};

export const MAKES_WITHOUT_MODELS = new Set(['tesla', 'polestar']);

// Handle variations for make/model combinations that may have different formats in Shopify
// Try expected format first, then known variations if the expected format doesn't work
export const HANDLE_VARIATIONS: Record<string, string[]> = {
  // Chevrolet C/K: try standard format first, then the hyphen-missing version
  'chevrolet/c-k': ['chevrolet-c-k', 'chevrolet-ck'],
  // Ford Country Sedan Wagon: try standard format first, then the "squire" typo version
  'ford/country-sedan-wagon': ['ford-country-sedan-wagon', 'ford-country-squire-wagon'],
};
